import React, { createContext, useEffect } from "react";
import Swal from 'sweetalert2';
import { useSocket } from "../hooks/useSocket";
import { getUsuarioStorage } from "../helpers/getUsuarioStorage";

export const SocketContext = createContext();

export const SocketProvider = ({ children }) => {

    // const server_url = process.env.REACT_APP_PRODUCCION;
    const server_url = process.env.REACT_APP_PRODUCCION
        ? new URL(process.env.REACT_APP_PRODUCCION).origin
        : 'http://localhost:8092';


    // 1. Usamos el hook de socket. 
    // Nota: Es mejor que useSocket no conecte automáticamente si no hay URL o datos.
    const { socket, online, conectarSocket, desconectarSocket } = useSocket(server_url);

    useEffect(() => {
        const usuario = getUsuarioStorage();
        console.log("usuario");
        console.log(usuario);

        if (usuario?.uidUsuario || usuario?.codigoEntidad) {
            // 2. Pasamos los datos por el query del handshake
            conectarSocket({
                query: {
                    codigoEntidad: usuario?.codigoEntidad,
                    ubicacion: usuario?.codigoUbicacion, // Pasamos la sede
                    uidUsuario: usuario?.uidUsuario || '',
                    uidModulo: usuario?.uidModulo || '',
                    modulo: usuario?.modulo || '',
                    usuario: usuario?.usuario || '',
                    agente: usuario?.agente || ''
                },
                transports: ['websocket', 'polling']
            });
        }
    }, [conectarSocket]); // Se dispara cuando el componente carga

    // 3. Opcional: Desconectar cuando el componente se destruye o el usuario hace logout
    useEffect(() => {
        const usuario = getUsuarioStorage();
        if (!usuario?.uidUsuario && !usuario?.codigoEntidad) {
            desconectarSocket();
        }
    }, [desconectarSocket]);

    // Escuchar el evento de expiración de sesión
    useEffect(() => {
        if (socket) {
            const handleSessionExpired = (data) => {
                Swal.fire('Sesión Expirada', data.msg, 'warning').then(() => {
                    localStorage.clear();
                    window.location.href = '/ingreso';
                });
            };
            socket.on('session-expired', handleSessionExpired);

            return () => {
                socket.off('session-expired', handleSessionExpired);
            }
        }
    }, [socket]);

    return (
        <SocketContext.Provider value={{
            socket,
            online,
            conectarSocket,
            desconectarSocket
        }}
        >
            {children}
        </SocketContext.Provider>
    )
}